import { defineMessages } from "react-intl";

const messages = defineMessages({
    moderation: {
        id: "menu.moderation",
    },
    registration: {
        id: "menu.registration",
    },
    login: {
        id: "menu.login",
    },
    logout: {
        id: "menu.logout",
    },
    account: {
        id: "menu.account",
    },
    help: {
        id: "help.title",
    },
    username: {
        id: "account.username",
    },
});

export default messages;
